const state = {
  locale: 'en',
  connect: false
}

export default state



// WEBPACK FOOTER //
// ./examples/store/state.js